import { render, staticRenderFns } from "./ValidWatcher.vue?vue&type=template&id=38057f8e&"
import script from "./ValidWatcher.vue?vue&type=script&lang=js&"
export * from "./ValidWatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports